module.exports = __webpack_public_path__ + "img/Socials.684ff2a0.svg";